
const API_SERVICES  =  {
    LOGIN: "/api/auth/login",
    TABLE_RECORD_SIZE:10,
    TABLE_RECORD_OPTIONS:[10, 50, 100, 200, 500, 1000, 2000],
    PASSWORD_PATTERN:'(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{6,16}$',
}


const FORM_MESSAGES = {
    REQUIRED: 'Required',
    INVALID_EMAIL: 'Invalid email address',
    INVALID_PHONE: 'Invalid phone number',
    INVALID_PASSWORD: 'Invalid password',
}

const PATTERNS = {
    PAN:'aaaaa9999a',
}

export default API_SERVICES;
export {FORM_MESSAGES, PATTERNS};
